import { type ImporterTask } from '~/store/tasks/types';

/** Local importer tasks removed when the import pane is closed — matches ImportManager `closePane`. */
export const getImportPaneCloseLocalTaskIds = (importerTasks: ImporterTask[]) =>
  importerTasks
    .filter(({ status }) => status === 'completed' || status === 'error')
    .map(({ localTaskId }) => localTaskId);
